import { render, staticRenderFns } from "./VideoCallDialog.vue?vue&type=template&id=439189fe&scoped=true&"
import script from "./VideoCallDialog.vue?vue&type=script&lang=js&"
export * from "./VideoCallDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallDialog.vue?vue&type=style&index=0&id=439189fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439189fe",
  null
  
)

export default component.exports